import React from 'react'
import { Wrapper } from './styled'

export const ProductSelectorFooter = () => {
  return (
    <Wrapper>
      © {new Date().getFullYear()} Sofia & Grace, All Rights Reserved.
    </Wrapper>
  )
}
